import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { LayoutProvider, useLayout } from './context/LayoutContext';
import Login from './pages/Login';
import HubSpotDashboard from './pages/HubSpotDashboard';
import QuarterlySalesDashboard from './pages/QuarterlySalesDashboard';
import WeeklyDealsProgression from './pages/WeeklyDealsProgression';
import DealsBoardDashboard from './pages/DealsBoardDashboard';
import './App.css';

function Navigation() {
  const { logout } = useAuth();
  const { mobileLayout } = useLayout();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // On mobile, sidebar is hidden by default
  if (mobileLayout && !sidebarOpen) {
    return (
      <button
        onClick={() => setSidebarOpen(true)}
        style={{
          position: 'fixed',
          top: '10px',
          left: '10px',
          zIndex: 1000,
          padding: '8px 12px',
          background: '#1e293b',
          color: '#fff',
          border: 'none',
          borderRadius: '6px',
          fontSize: '18px',
          cursor: 'pointer'
        }}
      >
        ☰
      </button>
    );
  }

  return (
    <>
      {/* Overlay for mobile */}
      {mobileLayout && sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0,0,0,0.5)',
            zIndex: 998
          }}
        />
      )}
      <nav className={`sidebar ${mobileLayout ? 'sidebar-mobile' : ''}`}>
        {mobileLayout && (
          <button
            onClick={() => setSidebarOpen(false)}
            style={{
              position: 'absolute',
              top: '10px',
              right: '10px',
              background: 'transparent',
              border: 'none',
              color: '#94a3b8',
              fontSize: '20px',
              cursor: 'pointer'
            }}
          >
            ✕
          </button>
        )}
        <div className="logo">
          <h2>Zetaris</h2>
          <span>HubSpot Sales</span>
        </div>
        <ul className="nav-links">
          {/* Hidden for now
          <li>
            <a href="/" className={`nav-link ${window.location.pathname === '/' ? 'active' : ''}`} onClick={() => mobileLayout && setSidebarOpen(false)}>
              <span className="icon">📊</span>
              Sales Dashboard
            </a>
          </li>
          <li>
            <a href="/quarterly" className={`nav-link ${window.location.pathname === '/quarterly' ? 'active' : ''}`} onClick={() => mobileLayout && setSidebarOpen(false)}>
              <span className="icon">📅</span>
              Quarterly Dashboard
            </a>
          </li>
          */}
          {/* Hidden for now
          <li>
            <a href="/weekly" className={`nav-link ${window.location.pathname === '/weekly' ? 'active' : ''}`} onClick={() => mobileLayout && setSidebarOpen(false)}>
              <span className="icon">📆</span>
              Weekly Progression
            </a>
          </li>
          */}
          <li>
            <a href="/deals" className={`nav-link ${window.location.pathname === '/deals' ? 'active' : ''}`} onClick={() => mobileLayout && setSidebarOpen(false)}>
              <span className="icon">🗂</span>
              Deals Board
            </a>
          </li>
        </ul>
        <div className="sidebar-footer">
          <button
            onClick={logout}
            style={{
              width: '100%',
              padding: '12px 16px',
              background: 'transparent',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: '8px',
              color: '#94a3b8',
              fontSize: '14px',
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => {
              e.target.style.background = 'rgba(255,255,255,0.1)';
              e.target.style.color = '#fff';
            }}
            onMouseOut={(e) => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#94a3b8';
            }}
          >
            <span>🚪</span> Logout
          </button>
        </div>
      </nav>
    </>
  );
}

function ProtectedApp() {
  const { isAuthenticated, isLoading, logout } = useAuth();
  const { mobileLayout } = useLayout();

  if (isLoading) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0f172a'
      }}>
        <div style={{ color: '#fff', fontSize: '18px' }}>Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return (
    <Router>
      <div className={`app ${mobileLayout ? 'app-mobile' : ''}`} style={{ display: 'flex', flexDirection: 'column' }}>
        {/* Minimal top bar with logout */}
        <div style={{
          display: 'flex', justifyContent: 'flex-end', alignItems: 'center',
          padding: '6px 16px', background: '#1e293b', gap: '12px'
        }}>
          <span style={{ color: '#94a3b8', fontSize: '12px' }}>Zetaris HubSpot Sales</span>
          <button
            onClick={logout}
            style={{
              padding: '4px 12px', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: '4px', color: '#94a3b8', fontSize: '12px', cursor: 'pointer'
            }}
          >
            Logout
          </button>
        </div>
        <main style={{ flex: 1, padding: '20px', background: '#f1f5f9', overflowY: 'auto' }}>
          <Routes>
            <Route path="/" element={<DealsBoardDashboard />} />
            <Route path="/quarterly" element={<QuarterlySalesDashboard />} />
            <Route path="/weekly" element={<WeeklyDealsProgression />} />
            <Route path="/deals" element={<DealsBoardDashboard />} />
          </Routes>
        </main>
      </div>
    </Router>
  );
}

function App() {
  return (
    <AuthProvider>
      <LayoutProvider>
        <ProtectedApp />
      </LayoutProvider>
    </AuthProvider>
  );
}

export default App;
